/**
 * 商户结算统计
 */
<template>
  <div>
    <div class="content-container">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>合同管理</el-breadcrumb-item>
      </el-breadcrumb>

      <!--列表-->
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="拼命加载中"
        style="width: 100%"
        class="table"
      >
        <el-table-column fixed prop="merchantName" label="商户名称" min-width="250">
        </el-table-column>
        <el-table-column prop="contractType" label="合同类型">
          <template slot-scope="scope">
            {{ scope.row.contractType === 0 ? "纸质" : "电子" }}
          </template>
        </el-table-column>
        <el-table-column prop="handlerName" label="经办人">
          <template slot-scope="scope">
            {{ scope.row.authorizeName || scope.row.legalName }}
          </template>
        </el-table-column>
        <el-table-column prop="handlerCard" label="经办人身份证" min-width="110">
          <template slot-scope="scope">
            {{ scope.row.authorizeCard || scope.row.legalCard }}
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="经办人手机号"> </el-table-column>
        <el-table-column prop="contractSignAt" label="签署时间">
          <template slot-scope="scope">
            {{ formatTimestamp(scope.row.contractSignAt) }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              plain
              @click="handleView(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getContractInfo } from "../../api/userMG";
export default {
  data() {
    return {
      listData: [],
      loading: false,
    };
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.contractInfo();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    contractInfo() {
      getContractInfo()
        .then((res) => {
          if (res.msg == "success") {
            if (res.data) {
              this.listData = [res.data];
            }
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
    handleView(row) {
      if (row.contract) {
        // 如果是浏览器环境且有URL，则打开新标签页
        window.open(row.contract, "_blank");
      } else {
        this.$message({
          message: "合同URL不存在",
          type: "error",
        });
      }
    },
    // 格式化时间戳为日期字符串（yyyy-MM-dd）
    formatTimestamp(timestamp) {
      if (timestamp <= 0) return "";
      const date = new Date(timestamp * 1000); // 将秒转换为毫秒
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(date.getDate()).padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}

/* 面包屑导航样式 */
.breadcrumb {
  margin-bottom: 25px; /* 与表格之间的间距 */
}
</style>

 


// WEBPACK FOOTER //
// src/views/manageCenter/contractManage.vue